const shop = {
  shopname: "店铺名称",
  contacts: "联系人",
  shopnamewidth: "60px",
  contactswidth: "55px",
  mobilewidth: "65px",
  logo: "LOGO",
  mobile: "联系电话",
  shoptime: "营业时间",
  address: "地址",
  addshop: "新增商铺",
  editshop: "编辑商铺",
  baseMessage: "基础信息",
  otherMessage: "其他信息",
  jianjie: "店铺简介",
  uploadImg: "上传店铺照片",
  formLeftWidth: "100px",
  formDetailWidth: "70px",
  photo: "请上传JPG/JPEG/PNG/GIF/SVG/BMP格式图片",
  tips: "请输入",
  tipsLength: "字符长度不能超过",
  uploadLOGO: "上传LOGO",
  detailTitle: "商铺详情",
  shopLink: "店铺链接"
} 
export default shop